import React, {PureComponent} from 'react';
import LazyImage from '../../common/lazy-image/LazyImage';
import CardPrice from './CardPrice';
import CardDescription from './CardDescription';
import StarRating from '@homeaway/react-star-rating-svg';

class Card extends PureComponent {
    render() {
        const {
            propertyName,
            link,
            bedrooms,
            bathrooms,
            sleeps,
            review,
            price,
            highlighted,
            onMouseOver,
            onMouseOut,
            onClick
        } = this.props;

        const classNames = highlighted
            ? 'great-place__card great-place__card--highlighted'
            : 'great-place__card';

        return (
            <div
                className={classNames}
                onMouseOver={onMouseOver}
                onMouseOut={onMouseOut}
                onClick={onClick}
            >
                <div className="great-place__card__image">
                    <LazyImage
                        className={'great-place__card__image-inner'}
                        source={this.props.imageSrc}
                        altText={propertyName}
                    />
                </div>

                <CardDescription
                    bedroomCount={bedrooms}
                    bathroomCount={bathrooms}
                    guestCount={sleeps}
                />
                <div className="great-place__card__footer">
                    <CardPrice price={price} />
                    <StarRating review={review} />
                </div>
                <a title={propertyName} href={link} />
            </div>
        );
    }
}

export default Card;
